import { render, staticRenderFns } from "./OtherLoanCaseCard.vue?vue&type=template&id=545c55c0"
import script from "./OtherLoanCaseCard.vue?vue&type=script&lang=js"
export * from "./OtherLoanCaseCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports